/* @flow */

export const donateLink = "https://infoxchange.giveeasy.org/ask-izzy"
export const aboutLink = "https://about.askizzy.org.au/about/"

